export class Dipendente {
  id: number;
  codice: string;
  nominativo: string;
  attivo: boolean;
  codFiscale:string;
  dataCreazione: Date;
  dataAssunzione: Date;
  dataLicenziamento: Date;
  dataNascita:Date;
  idReparto: number;
  idResponsabile: number;
  idMansione: number;
}